import API from '../..';
const ENTITY = 'core';
const config = { headers: { 'Content-Type': 'application/json' } };

export const getTableSettings = (tableKey) =>
    API.get(`/api/v1/${ENTITY}/settings-configuration/`, {
        params: { key: tableKey },
    });
export const saveTableSettings = (data) =>
    API.post(`/api/v1/${ENTITY}/settings-configuration/`, data, config);

export const filterPanels = ({
    orderBy = 'created_at',
    page = 1,
    perPage = 25,
    searchText = '',
    sortBy = null,
} = {}) =>
    API.get(`/api/v1/${ENTITY}/panels/`, {
        params: {
            order_by: orderBy,
            page: page,
            per_page: perPage,
            search: searchText,
            sort: sortBy,
        },
    });

export const filterSystemTypesList = (type) =>
    API.get(`/api/v1/${ENTITY}/system-types/`, {
        params: {
            type_application: type,
        },
    });
export const getProposalContent = (proposalId) =>
    API.get(`/api/v1/${ENTITY}/contents/${proposalId}/`);
export const updateContent = (contentId, data) =>
    API.patch(`/api/v1/${ENTITY}/contents/${contentId}/`, data, config);
export const getRoofTypes = () => API.get(`/api/v1/${ENTITY}/roof-types/`);
